import { useState, useEffect } from "react"

// A tiny custom debounce hook
export function useDebounce<T>(value: T, delay = 700): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(handler)
  }, [value, delay])

  return debounced
}
